import { render, staticRenderFns } from "./DeliveryAddressForm.vue?vue&type=template&id=6dd98ffe"
import script from "./DeliveryAddressForm.vue?vue&type=script&lang=js"
export * from "./DeliveryAddressForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports